import { RenderIcon } from '@/components';
import type { Routes } from '@/utils';
import { type MenuOption } from 'naive-ui';
import { h, type Component } from 'vue';
import { RouterLink } from 'vue-router';

export class MenuItem {
	name: string;
	router: string;
	icon: Component | null;
	children: Array<MenuItem> | null;

	constructor(
		name: string,
		routerName: string,
		icon: Component | null = null,
		children: Array<MenuItem> | null = null,
	) {
		this.name = name;
		this.router = routerName;
		this.icon = icon;
		this.children = children;
	}

	static create(
		name: string,
		routerName: Routes | null,
		icon: Component | null = null,
		children: MenuOption[] | null = null,
		params: Record<string, string> = {},
	): MenuOption {
		const key = routerName ? String(routerName) : name;
		let menu: MenuOption = {
			key,
			label: () =>
				routerName
					? h(
							RouterLink,
							{
								to: { name: routerName, params },
							},
							{ default: () => h('span', name) },
					  )
					: h('span', name),
		};
		if (children && children.length > 0) menu = { ...menu, children };
		if (icon) menu = { ...menu, icon: RenderIcon(icon) };
		return menu;
	}
}

export default MenuItem;
